
import { useParams } from "react-router-dom";
import DashboardLayout from "@/components/layouts/DashboardLayout";
import AddInteractionForm from "@/components/contact-detail/AddInteractionForm";

const AddInteraction = () => {
  const { id } = useParams();

  return (
    <DashboardLayout>
      <div className="bg-[#F7F5F2] py-10">
        <div className="container mx-auto px-4">
          <AddInteractionForm />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddInteraction;
